module.exports = {
  colors: {
    brand: {
      primary: "#19C1DB",
      secondary: "#9747FF",
      danger: "#FF1515",
      success: "#C2EAA6",
      warning: "#F2C48D",
    },
    gray: {
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#D9D9D9",
      400: "#B3B1B1",
      500: "#878787",
      600: "#7A7979",
      700: "#5F5F5F",
      800: "#3C3C3C",
      900: "#151515",
    },
    background: {
      default: "#FFFFFF",
      muted: "#F5F5F5",
    },
    text: {
      default: "#1B1B1F",
      muted: "#5F5F5F",
    },
  },
  typography: {
    h1: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 700,
      size: "40px",
      line: 1.2,
    },
    h2: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 700,
      size: "32px",
      line: 1.3,
    },
    h3: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 600,
      size: "20px",
      line: 1.35,
    },
    body: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 400,
      size: "18px",
      line: 1.5,
    },
    bodyLg: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 400,
      size: "20px",
      line: 1.4,
    },
    bodySm: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 400,
      size: "16px",
      line: 1.45,
    },
    caption: {
      family:
        "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      weight: 400,
      size: "14px",
      line: 1.4,
    },
  },
  radius: {
    sm: 4,
    md: 6,
    lg: 8,
    xl: 12,
  },
  shadow: {
    card: "0 1px 2px rgba(0, 0, 0, 0.08)",
  },
  buttons: {
    primary: {
      bg: "#19C1DB",
      text: "#FFFFFF",
      hover: "#17A7C4",
    },
    secondary: {
      border: "#19C1DB",
      text: "#19C1DB",
      hoverBg: "rgba(25, 193, 219, 0.1)",
    },
    danger: {
      bg: "#FF1515",
      text: "#FFFFFF",
      hover: "#D91111",
    },
    warning: {
      bg: "#F2C48D",
      text: "#1B1B1F",
      hover: "#D9AC6E",
    },
    disabled: {
      bg: "#D9D9D9",
      text: "#7A7979",
    },
  },
};
